// src/components/sections/SaoLourencoSection/SaoLourencoSection.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './SaoLourencoSection.css';

const SaoLourencoSection = () => {
  return (
    <section id="sao-lourenco" className="section sl-section">
      <div className="container">
        <div className="sl-banner-content">
          <Link to="/sao-lourenco" className="sl-banner-image">
            <img src="/images/SaoLourencoSection/parque-das-aguas.webp" alt="Entrada do Parque das Águas em São Lourenço" />
            </Link>
          <div className="sl-banner-text">
            <h3 className="sl-subtitle">O Coração do Circuito das Águas</h3>
            <h2 className="sl-title">Descubra São Lourenço</h2>
            <p className="sl-description">
              Mergulhe na tranquilidade de uma das mais charmosas estâncias hidrominerais do Brasil.
              Explore as fontes terapêuticas do Parque das Águas, delicie-se com a autêntica gastronomia mineira
              e deixe-se encantar pela hospitalidade de uma cidade que inspira bem-estar.
            </p>
            <div className="sl-button-container">
              <Link to="/sao-lourenco" className="btn btn-primary">
                Saiba Mais sobre a Cidade
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaoLourencoSection;